import { render, staticRenderFns } from "./UpdatedDate.vue?vue&type=template&id=03b4d78e&"
import script from "./UpdatedDate.vue?vue&type=script&lang=ts&"
export * from "./UpdatedDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports